module.exports = __webpack_public_path__ + "media/images/pages/careers-week/hero-b8e48557fe48fc693280f898a794e96b.jpg";